/**
 * @generated SignedSource<<ef89cf0f71ecfe05d4534ec9908336f3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type SignatureEnvelopeState = "CANCELLED" | "CERTIFYING" | "COMPLETED" | "COMPLETING" | "SIGNING" | "%future added value";
export type SignatureState = "REJECTED" | "SIGNED" | "WAITING" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type FileRenderer_node$data = {
  readonly __typename: string;
  readonly canCreateSignatureEnvelope?: {
    readonly value: boolean;
  };
  readonly canRename?: {
    readonly value: boolean;
  };
  readonly content?: {
    readonly __typename: "File";
    readonly fileName: string;
    readonly fileNameWithExtension: string;
    readonly id: string;
    readonly mimeType: string;
    readonly name: string;
    readonly size: number;
    readonly url: URIString;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
  readonly draftContent_FileRenderer?: {
    readonly __typename: "File";
    readonly fileName: string;
    readonly fileNameWithExtension: string;
    readonly id: string;
    readonly mimeType: string;
    readonly name: string;
    readonly size: number;
    readonly url: URIString;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
  readonly id: string;
  readonly name?: string;
  readonly signatureEnvelope?: {
    readonly canSign: {
      readonly value: boolean;
    };
    readonly currentFile: {
      readonly __typename: "File";
      readonly fileName: string;
      readonly fileNameWithExtension: string;
      readonly id: string;
      readonly mimeType: string;
      readonly name: string;
      readonly size: number;
      readonly url: URIString;
    };
    readonly id: string;
    readonly signatures: {
      readonly nodes: ReadonlyArray<{
        readonly id: string;
        readonly member: {
          readonly id: string;
        };
        readonly status: SignatureState;
      }>;
    };
    readonly status: SignatureEnvelopeState;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"DownloadButton_node" | "FolderNodePublishBar_folderNode" | "ItemOpenedTracker_item" | "SignatureStatusFileRenderer_node" | "useNodeSecurity_node">;
  readonly " $fragmentType": "FileRenderer_node";
};
export type FileRenderer_node$key = {
  readonly " $data"?: FileRenderer_node$data;
  readonly " $fragmentSpreads": FragmentRefs<"FileRenderer_node">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fileName",
  "storageKey": null
},
v4 = {
  "alias": "fileNameWithExtension",
  "args": [
    {
      "kind": "Literal",
      "name": "ensureExtension",
      "value": true
    }
  ],
  "kind": "ScalarField",
  "name": "fileName",
  "storageKey": "fileName(ensureExtension:true)"
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mimeType",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "size",
  "storageKey": null
},
v8 = [
  (v0/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "type": "File",
    "abstractKey": null
  }
],
v9 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "content",
  "plural": false,
  "selections": (v8/*: any*/),
  "storageKey": null
},
v10 = [
  (v9/*: any*/)
],
v11 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "value",
    "storageKey": null
  }
],
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "AuthorizationResult",
  "kind": "LinkedField",
  "name": "canCreateSignatureEnvelope",
  "plural": false,
  "selections": (v11/*: any*/),
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FileRenderer_node",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FolderNodePublishBar_folderNode"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ItemOpenedTracker_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useNodeSecurity_node"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DownloadButton_node"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SignatureStatusFileRenderer_node"
    },
    {
      "kind": "InlineFragment",
      "selections": (v10/*: any*/),
      "type": "AnnouncementAttachment",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v10/*: any*/),
      "type": "MemberDetailsAttachment",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "AuthorizationResult",
          "kind": "LinkedField",
          "name": "canRename",
          "plural": false,
          "selections": (v11/*: any*/),
          "storageKey": null
        },
        (v9/*: any*/),
        (v12/*: any*/)
      ],
      "type": "FolderItem",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v9/*: any*/),
        (v12/*: any*/)
      ],
      "type": "VaultItem",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SignatureEnvelope",
          "kind": "LinkedField",
          "name": "signatureEnvelope",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            (v13/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "SignaturesConnection",
              "kind": "LinkedField",
              "name": "signatures",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Signature",
                  "kind": "LinkedField",
                  "name": "nodes",
                  "plural": true,
                  "selections": [
                    (v1/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Member",
                      "kind": "LinkedField",
                      "name": "member",
                      "plural": false,
                      "selections": [
                        (v1/*: any*/)
                      ],
                      "storageKey": null
                    },
                    (v13/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AuthorizationResult",
              "kind": "LinkedField",
              "name": "canSign",
              "plural": false,
              "selections": (v11/*: any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "File",
              "kind": "LinkedField",
              "name": "currentFile",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/),
                (v2/*: any*/),
                (v3/*: any*/),
                (v4/*: any*/),
                (v5/*: any*/),
                (v6/*: any*/),
                (v7/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "SignableInterface",
      "abstractKey": "__isSignableInterface"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "draftContent_FileRenderer",
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "content",
          "plural": false,
          "selections": (v8/*: any*/),
          "storageKey": null
        }
      ],
      "type": "VaultDraftItem",
      "abstractKey": null
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
})();

(node as any).hash = "2f5a8cda8ec82be9525034d48eafa76a";

export default node;
